<style scoped>
    .filtro {
        border: 2px solid #ccc;
        margin-bottom: 16px;
        position: relative;
    }

    .filtro-content {
        overflow: hidden;
    }

    .filtro .delete-filtro {
        border: 2px solid #ccc;
        background-color: #aaa;
        color: #fff;
        display: block;
        width: 30px;
        height: 30px;
        font-weight: bold;
        font-size: 30px;
        text-align: center;
        border-radius: 50px;
        position: absolute;
        top: -15px;
        right: -15px;
        line-height: 0.85;
        cursor: pointer;
    }
</style>

<style>
    .filtro .CodeMirror {
        margin-top: 16px;
        font-size: 10px;
        height: 150px;
    }
</style>

<template>
    <div>
        <div class="xrow">
            <div class="col-1-1 actions edit-buttons">
                <button type="button" class="button button-primary" v-on:click="addFiltro">
                    Adicionar Filtro
                </button>
            </div>
            <div class="col-1-1">
                <div class="form-group">
                    <label>Filtros do dashboard</label>
                </div>

                <div class="filtro caption" v-if="dashboard.filtros.length === 0">
                    Nenhum filtro vinculado ...
                </div>

                <div v-for="(filtro, idx) in orderedFiltros" :key="idx">
                    <div class="filtro">
                        <a class="delete-filtro" v-on:click="deleteFiltro(filtro)">
                            &times;
                        </a>
                        <div class="filtro-content">
                            <div class="col-1-3">
                                <div class="form-group">
                                    <label>Ordem de exibicao</label>
                                    <input class="form-control" type="number" v-model.number="filtro.ordem" />
                                </div>
                                <div class="form-group">
                                    <label>Tipo de filtro</label>
                                    <select class="form-control" v-model="filtro.tipo">
                                        <option value="date">Data</option>
                                        <option value="month">Mes</option>
                                        <option value="text">Texto</option>
                                        <option value="number">Numerico</option>
                                        <option value="select">Selecao Dropdown (Select)</option>
                                        <option value="multiselect">Multiplas Opcoes (Multi-Select)</option>
                                    </select>
                                </div>
                                <div class="form-group">
                                    <label>Nome do Filtro</label>
                                    <input class="form-control" type="text" v-model="filtro.rotulo" @input="autoChave(filtro)" />
                                </div>
                                <div class="form-group">
                                    <label>Identificador</label>
                                    <input class="form-control" type="text" v-model="filtro.chave" />
                                    <small class="text-muted">Usado no SQL como <code>:REQUEST_{{ filtro.chave || '...' }}</code></small>
                                </div>
                                <div class="form-group">
                                    <label>Largura (colunas 1-12)</label>
                                    <input class="form-control" type="number" v-model.number="filtro.largura" min="1" max="12" />
                                </div>
                                <div class="form-group">
                                    <label>
                                        <input type="checkbox" v-model="filtro.obrigatorio">
                                        Preenchimento obrigatorio
                                    </label>
                                </div>
                            </div>

                            <div class="col-1-3">
                                <div class="form-group">
                                    <label>Tipo de valor padrao</label>
                                    <select class="form-control" v-model="filtro.valorpadrao_tipo">
                                        <option value="TEXT">Texto plano / Expressao</option>
                                        <option value="SQL">Consulta SQL</option>
                                    </select>
                                    <div class="form-group" v-if="filtro.valorpadrao_tipo === 'SQL'">
                                        <label>Local de execucao da Query</label>
                                        <select v-model="filtro.banco_valorpadrao" class="form-control">
                                            <option value="local">Banco de dados Versotech</option>
                                            <option value="erp">Banco de dados ERP</option>
                                        </select>
                                    </div>
                                    <codemirror
                                        v-if="filtro.valorpadrao_tipo === 'SQL'"
                                        v-model="filtro.valor_padrao"
                                        :options="code_options">
                                    </codemirror>
                                    <div v-else>
                                        <input class="form-control mt-2" type="text" v-model="filtro.valor_padrao" placeholder="Ex: DATE_NOW, DATE_30_DAYS_AGO, valor fixo..." />
                                        <small class="text-muted">Expressoes: DATE_NOW, DATE_THIS_MONTH_START, DATE_30_DAYS_AGO, DATE_7_DAYS_AGO, CURRENT_MONTH</small>
                                    </div>
                                </div>
                            </div>

                            <div class="col-1-3">
                                <div class="form-group">
                                    <label>Opcoes (Para campos de selecao)</label>
                                    <select class="form-control" v-model="filtro.opcoes_tipo" :disabled="!opcoesVisible(filtro)">
                                        <option value="TEXT">Texto (separar por linha)</option>
                                        <option value="SQL">Consulta SQL</option>
                                    </select>

                                    <div class="form-group" v-if="filtro.opcoes_tipo === 'SQL' && opcoesVisible(filtro)">
                                        <label>Local de execucao da Query</label>
                                        <select v-model="filtro.banco_opcoes" class="form-control">
                                            <option value="local">Banco de dados Versotech</option>
                                            <option value="erp">Banco de dados ERP</option>
                                        </select>
                                    </div>

                                    <codemirror
                                        v-if="opcoesVisible(filtro)"
                                        v-model="filtro.opcoes"
                                        :options="code_options">
                                    </codemirror>
                                    <div v-else class="mt-2">
                                        <small class="text-muted">Disponivel apenas para tipos Select e Multi-Select</small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="xrow">
            <div class="col-1-1">
                <h4>O que sao os filtros?</h4>
                <p>
                    <small>
                        Filtros sao campos de formulario exibidos no topo do dashboard. Quando o usuario preenche e aplica os filtros,
                        os valores sao repassados para dentro do SQL dos widgets, identificados pelo "Identificador" do filtro.
                    </small>
                </p>
                <br>
                <h4>Identificador do filtro</h4>
                <p>
                    <small>
                        O Identificador sera utilizado dentro do SQL dos widgets com o prefixo <strong>:REQUEST_</strong>.
                        Por exemplo, se o identificador for <strong>data_inicio</strong>, no SQL do widget use:
                        <strong><pre>WHERE datahora >= :REQUEST_data_inicio</pre></strong>
                        Se o usuario nao preencher um filtro opcional, a linha com a variavel e removida automaticamente.
                    </small>
                </p>
                <br>
                <h4>Valor padrao</h4>
                <p>
                    <small>
                        Para expressoes de texto, use: <strong>DATE_NOW</strong> (data atual), <strong>DATE_30_DAYS_AGO</strong> (30 dias atras),
                        <strong>DATE_THIS_MONTH_START</strong> (inicio do mes), <strong>DATE_THIS_YEAR_START</strong> (inicio do ano).
                    </small>
                </p>
                <p>
                    <small>
                        Para SQL, retorne um alias <strong>"valor"</strong>:
                        <strong><pre>SELECT NOW()::DATE AS valor</pre></strong>
                    </small>
                </p>
                <br>
                <h4>Opcoes (para Select e Multi-Select)</h4>
                <p>
                    <small>
                        Para SQL, retorne os aliases <strong>"chave"</strong> e <strong>"valor"</strong>:
                        <strong>
                            <pre>
SELECT id      as chave,
       nome    as valor
  FROM colaborador
 WHERE ativo = true</pre>
                        </strong>
                        Para tipo texto, informe um valor por linha.
                    </small>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
  import { codemirror } from 'vue-codemirror'

  import 'codemirror/lib/codemirror.css'
  import 'codemirror/theme/monokai.css'
  import 'codemirror/addon/selection/active-line.js'
  import 'codemirror/mode/sql/sql.js'
  import 'codemirror/addon/display/autorefresh.js'
  import 'codemirror/addon/edit/closetag.js'

  import _orderBy from 'lodash/orderBy'
  import _max from 'lodash/max'
  import _filter from 'lodash/filter'

  const newFiltro = (ordem) => {
    return {
      ordem,
      rotulo: '',
      chave: '',
      tipo: 'date',
      obrigatorio: false,
      valor_padrao: '',
      valorpadrao_tipo: 'TEXT',
      banco_valorpadrao: 'local',
      opcoes: '',
      opcoes_tipo: 'TEXT',
      banco_opcoes: 'local',
      largura: 3,
      ativo: true,
      configuracao: {},
    }
  }

  export default {
    name: 'FiltrosDashboardTab',
    components: {
      codemirror
    },
    props: [
      'dashboard',
    ],
    computed: {
      orderedFiltros() {
        return _orderBy(this.dashboard.filtros, 'ordem')
      }
    },
    data() {
      return {
        code_options: {
          tabSize: 4,
          styleActiveLine: true,
          lineNumbers: true,
          line: true,
          mode: 'text/x-sql',
          autoRefresh: true,
          lineWrapping: true,
          theme: 'monokai',
          showCursorWhenSelecting: true,
          highlightSelectionMatches: {
            showToken: /\w/,
            annotateScrollbar: true
          },
        },
      }
    },
    methods: {
      opcoesVisible(filtro) {
        return ['select', 'multiselect'].indexOf(filtro.tipo) >= 0;
      },
      addFiltro() {
        if (!this.dashboard.filtros) {
          this.$set(this.dashboard, 'filtros', []);
        }
        let max = _max(this.dashboard.filtros, 'ordem')
        let filtro = newFiltro(!!max ? +max.ordem + 1 : 1)
        this.dashboard.filtros.push(filtro);
      },
      deleteFiltro(filtro) {
        this.dashboard.filtros = _filter(this.dashboard.filtros, (f) => f !== filtro);
      },
      autoChave(filtro) {
        if (filtro.id) return;
        filtro.chave = filtro.rotulo
          .toLowerCase()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .replace(/[^a-z0-9]+/g, '_')
          .replace(/^_|_$/g, '');
      },
    }
  };
</script>
